// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"12ca4a02","937":"3bef63bd"}[chunkId] + ".chunk.css";
};